import { useEffect } from 'react'

const useClickOutside = (
  refElementOne,
  refElementTwo,
  callback,
  flag
) => {
  useEffect(() => {
    const hideElement = (e) => {
      if (
        (refElementOne.current &&
          refElementOne.current.contains(e.target)) ||
        (refElementTwo.current &&
          refElementTwo.current.contains(e.target))
      ) {
        return
      }

      callback(false)
    }

    if (flag) {
      document.addEventListener('click', hideElement)
    } else {
      document.removeEventListener('click', hideElement)
    }
    return () => {
      document.removeEventListener('click', hideElement)
    }
  }, [flag, callback, refElementOne, refElementTwo])
}

export default useClickOutside
